import { render, staticRenderFns } from "./index.vue?vue&type=template&id=190dea7c&lang=html&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mychefkoo/Documents/cloud-dom/cloud-web/erp-flexible-web21/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('190dea7c')) {
      api.createRecord('190dea7c', component.options)
    } else {
      api.reload('190dea7c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=190dea7c&lang=html&", function () {
      api.rerender('190dea7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueQuillEditorMerchandise/div/index.vue"
export default component.exports